import styled from 'styled-components';
import { Filter16 } from 'ui/icons';
import { borderColors, borderRadius, colors, duration, fadeIn, fadeOut, spacing } from 'ui/theme';
import { testIds } from './QueryBuilder';
import { testIds as sidePanelTestIds } from '../sidePanel/SidePanel';
import { GhostButton } from 'ui/button';

export const QueryBuilderSectionWrapper = styled.div`
  background-color: ${colors.grey5};
  border-radius: ${borderRadius.xl};
  border: ${spacing.single} solid ${borderColors.borderPrimarySubtle};
  margin: 0 ${spacing.double} ${spacing.double};
  padding: ${spacing.half};
  z-index: 2; /* mimic the z-index of QueryBuilderWrapper, otherwise some components using portals will be hidden/blank */
  [data-test=${testIds.queryBuilderWrapper}] {
    padding: ${spacing.base} ${spacing.half};
    [data-test=${sidePanelTestIds.panel}] {
      position: static;
    }
  }

  &[data-header-collapsed="true"] {
    [data-test="filter-users-button"] {
      animation-name: ${fadeIn};
    }
    [data-test="hide-query-builder-button"] {
      animation-name: ${fadeOut};
    }
  }

  &[data-header-collapsed="false"] {
    [data-test="filter-users-button"] {
      animation-name: ${fadeOut};
    }
    [data-test="hide-query-builder-button"] {
      animation-name: ${fadeIn};
    }
  }
`;

export const FilterUsersFurtherHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FilterUsersFurtherHeaderActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.double};
  > * button {
    box-shadow: none;
    &:active {
      box-shadow: none;
    }
  }
`;

export const QueryBuilderHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledFilterIcon = styled(Filter16)`
  margin-right: ${spacing.quarter};
  margin-top: ${spacing.eighth};
`;

export const UsersCountWrapper = styled.div`
  display: flex;
  align-items: end;
`;

export const UsersSuffix = styled.div`
  color: ${colors.textSecondary};
  margin-left: ${spacing.quarter};
`;

export const StyledGhostButton = styled(GhostButton)`
  box-shadow: none;  
  &:active {
    box-shadow: none;
  }
  animation-duration: ${duration.dramatic};
`;
